module.exports = __webpack_public_path__ + "img/load.0ad6a0ce.gif";